import type { IconSvgObject } from './types';

const MinusPlus01Icon: IconSvgObject = [
  ["path", { d: "M12 7V21M19 14H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 3L5 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MinusPlus01Icon;
